import { render, staticRenderFns } from "./CompContactsModalContacts.vue?vue&type=template&id=61a92cf4"
import script from "./CompContactsModalContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./CompContactsModalContacts.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompContactsModalContacts.vue?vue&type=style&index=0&id=61a92cf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports